import { WINDOW_SHORTCUTS, isModalOpen, shouldSkipShortcut } from '@/shared/lib/keyboard';

/**
 * 창 틀 onKeyDown — 포커스가 그 창 안에 있을 때 Alt+W 는 닫기, Alt+M 은 최소화.
 * 창 버튼과 같은 핸들러를 불러 닫힘 애니메이션과 포커스 이양을 그대로 탄다.
 */
export function handleWindowShortcut(
  e: KeyboardEvent,
  close: () => void,
  minimize: () => void
): void {
  if (shouldSkipShortcut(e) || isModalOpen()) return;
  const action = WINDOW_SHORTCUTS.closeWindow.match(e)
    ? close
    : WINDOW_SHORTCUTS.minimizeWindow.match(e)
      ? minimize
      : null;
  if (!action) return;
  e.preventDefault();
  action();
}
